import * as React from 'react';
export const pauseSvg = React.forwardRef(function pauseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.6 3.61a.7.7 0 0 1 .7.7v3.375a.7.7 0 0 1-1.4 0V4.31a.7.7 0 0 1 .7-.7Zm2.8 0a.7.7 0 0 1 .7.7v3.375a.7.7 0 0 1-1.4 0V4.31a.7.7 0 0 1 .7-.7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm0 1.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Z',
    }),
  );
});
pauseSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pause = {
  category: 'icon',
  colorable: true,
  name: 'pause',
  svg: pauseSvg,
};
